export default __webpack_public_path__ + "3caa26bf8669875bbef3ba4880f2b946.png";